import { Button, Grid, Typography } from '@mui/material';
import * as Sentry from '@sentry/browser';
import React, { ErrorInfo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Outlet } from 'react-router-dom';

// TODO: replace with Sentry.ErrorBoundary after upgrading to React 18
export default class ErrorBoundary extends React.Component<
{ children: JSX.Element | React.ReactNode },
{ hasError: boolean; error: string }
> {
    state = { hasError: false, error: '' };
    componentDidCatch(error: Error, info: ErrorInfo) {
        // Display fallback UI
        this.setState({ hasError: true, error: `${error}` });
        // Send error to Sentry
        Sentry.captureMessage('Error in Components', { extra: { error: error, stack: info } });
    }

    handleReload = () => {
        this.setState(
            prev => ({ hasError: false, error: '' }),
            () => {
                if (this.state.hasError) {
                    // cannot use any router location hooks in this component
                    window.location.reload();
                }
            },
        );
    };
    render() {
        if (this.state.hasError) {
            return (
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    style={{ minHeight: '100vh', textAlign: 'center' }}
                >
                    <Typography component="p">
                        <FormattedMessage id="error.boundary" />
                    </Typography>
                    <Button variant="contained" color="primary" onClick={this.handleReload}>
                        <FormattedMessage id="error.boundary.reload" />
                    </Button>
                </Grid>
            );
        }
        return <>{this.props.children ? this.props.children : <Outlet />}</>;
    }
}
